import React, { memo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingFallback from "../components/elements/LoadingFallback";
import { useSelector } from "react-redux";
import { OrganizationProvider } from "../context/OrganizationContext";
import PageNotFound from "../pages/PageNotFound";

const OrganizationRoute = memo(function OrganizationRoute({ children }) {
  const navigate = useNavigate();
  const { session } = useSelector((state) => state?.authProvider);
  const { selectedOrganization, organizations } = useSelector(
    (state) => state?.organization
  );
  const { lang } = useSelector((state) => state?.langProvider);

  useEffect(() => {
    if (session?.status === "unauthorized") {
      navigate("/login");
    } else if (
      session?.status === "authorized" &&
      ["admin", "user"].includes(session?.user?.role?.toLowerCase())
    ) {
      if (session?.user?.role?.toLowerCase() === "admin") {
        navigate(`/${lang}/admin/dashboard`);
      } else {
        navigate(`/${lang}/`);
      }
    }
  }, [session?.status, session?.user?.role?.toLowerCase(), navigate]);

  if (session?.status === "loading") {
    return <LoadingFallback />;
  }

  return session?.status === "authorized" &&
    session?.user?.role?.toLowerCase() === "organization" ? (
    <OrganizationProvider
      organizations={organizations?.data?.data || []}
      selectedOrganization={selectedOrganization}
      loading={organizations?.loading}
    >
      {children}
    </OrganizationProvider>
  ) : (
    <PageNotFound />
  );
});

export default OrganizationRoute;
